export default {
      id: "social-facebook-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#social-facebook-usage",
      toString: function () {
        return this.url;
      }
    }